import './App.css';
import React, { useEffect } from 'react';
import Router from './pages/router/Router';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';
import { pushGtmDataLayer } from './utils/gtm';

const isProductionGTM = true; // Set to true for testing purposes, replace with actual environment variable in production

function App() {
  const location = useLocation();

  useEffect(() => {
    if (!isProductionGTM) return;

    pushGtmDataLayer({
      event: 'page_view',
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);

  return (
    <main>
      <Router />
    </main>
  );
}

export default App;
